import BaseService from "../../base/base_service";


export default class ComponentFactoryService extends BaseService {
    static CLASS = 'ComponentFactoryService';

    createComponent(componentPrototype, params) {
        return componentPrototype.create(params);
    }



}
